import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './title-link-block.scss.js';

class TitleLinkBlock extends s {
    constructor() {
        super(...arguments);
        this.title = 'default title';
        this.titleSize = 'medium';
        this.titleColor = 'black';
        this.titleAlignment = 'left';
        this.description = '';
        this.background = 'purple';
        this.links = [];
    }
    renderLinks() {
        return this.links.map((item) => $ `<div class="link-item"><a href="${item.Url}">${item.Link}</a><p class="description">${item.Description}</p></div>`);
    }
    render() {
        return $ `<section class="container"><div class="header section-background-${this
            .background} title-alignment-${this.titleAlignment}"><h2 class="title title-color-${this.titleColor} ${this.titleSize}">${this.title}</h2><p class="description">${this.description}</p></div><div class="link-list">${this.renderLinks()}</div></section>`;
    }
}
TitleLinkBlock.styles = css_248z;
__decorate([
    e({ type: String })
], TitleLinkBlock.prototype, "title", void 0);
__decorate([
    e({ type: String })
], TitleLinkBlock.prototype, "titleSize", void 0);
__decorate([
    e({ type: String })
], TitleLinkBlock.prototype, "titleColor", void 0);
__decorate([
    e({ type: String })
], TitleLinkBlock.prototype, "titleAlignment", void 0);
__decorate([
    e({ type: String })
], TitleLinkBlock.prototype, "description", void 0);
__decorate([
    e({ type: String })
], TitleLinkBlock.prototype, "background", void 0);
__decorate([
    e({
        type: Array,
        converter: {
            fromAttribute(value) {
                try {
                    return JSON.parse(value);
                }
                catch (e) {
                    return [];
                }
            },
            toAttribute(value) {
                return JSON.stringify(value);
            },
        },
    })
], TitleLinkBlock.prototype, "links", void 0);
customElements.define('title-link-block', TitleLinkBlock);

export { TitleLinkBlock };
